module.exports = __webpack_public_path__ + "static/img/icon-a-huabanbeifen27.377f921.svg";


//////////////////
// WEBPACK FOOTER
// ./icons/svg/icon-a-huabanbeifen27.svg
// module id = PWF1
// module chunks = 49